import { render, staticRenderFns } from "./AuthorTable.vue?vue&type=template&id=7a094584"
import script from "./AuthorTable.vue?vue&type=script&lang=js"
export * from "./AuthorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports